import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import ps from "../assets/img/photoshop.png";
import ae from "../assets/img/after-effects.png";
import ai from "../assets/img/illustrator.png";
import figma from "../assets/img/figma.png";
import dav from "../assets/img/davinci.png";
import pp from "../assets/img/pp.png";
// import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Adobe Photoshop",
      description: "Photo Editing",
      imgUrl: ps,
    },
    {
      title: "Adobe After Effects",
      description: "Animations & Promos",
      imgUrl: ae,
    },
    {
      title: "Adobe Illustrator",
      description: "Logo and Branding",
      imgUrl: ai,
    },
    {
      title: "Figma",
      description: "UI/UX Mockups",
      imgUrl: figma,
    },
    {
      title: "Davinci Resolve",
      description: "Video Editing",
      imgUrl: dav,
    },
    {
      title: "Premiere Pro",
      description: "Video Editing",
      imgUrl: pp,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Tools we use</h2>
                  <p>
                    We have made a variety of projects for different events
                    which includes the usage of design tools like Adobe
                    Illustrator, Adobe Photoshop, Adobe After Effect, Canva,
                    Figma, Davince Resolve 18
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <button className="vvd">
                        <span>We play with!</span>
                      </button>
                      {/* <Nav.Item>
                        <Nav.Link eventKey="first">We play with!</Nav.Link>
                      </Nav.Item> */}
                      {/* <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item> */}
                    </Nav>
                    <section className="project-grid" id="project-grid">
                      <Tab.Content
                        id="slideInUp"
                        className={
                          isVisible
                            ? "animate__animated animate__slideInUp"
                            : ""
                        }
                      >
                        <Tab.Pane eventKey="first">
                          <Row>
                            {projects.map((project, index) => {
                              return <ProjectCard key={index} {...project} />;
                            })}
                          </Row>
                        </Tab.Pane>
                      </Tab.Content>
                    </section>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {/* <img className="background-image-right" src={colorSharp2} alt="img"></img> */}
    </section>
  );
};
